<template>
    <div class="ppv2-w-full ppv2-space-y-2 ppv2-min-w-0" :class="customContainerClass">
        <BaseLabel v-if="label" :customClass="customClassLabel" :label="label" :required="required" :iconRight="iconRight">
        </BaseLabel>

        <div class="ppv2-relative" :class="{ '!ppv2-mt-0': customContainerClass }">
            <div class="ppv2-flex ppv2-items-center ppv2-gap-2">
                <!-- Color Preview / Trigger -->
                <div
                    class="ppv2-w-8 ppv2-min-w-8 ppv2-h-8 ppv2-min-h-8 ppv2-rounded ppv2-cursor-pointer ppv2-border ppv2-border-gray-200"
                    :class="{ 'ppv2-border-red-500': errorText }"
                    :style="{ backgroundColor: modelValue }"
                    @click.stop="togglePicker"
                ></div>

                <!-- Hex Input -->
                <div
                    class="ppv2-flex ppv2-items-center ppv2-p-1 ppv2-border ppv2-rounded-lg ppv2-flex-1 ppv2-min-w-0 ppv2-w-full"
                    :class="[errorText ? 'ppv2-border-red-500' : 'ppv2-border-[#9c9af880]']"
                >
                    <span class="ppv2-text-black ppv2-text-opacity-70 ppv2-mr-2">#</span>
                    <input
                        type="text"
                        :value="displayValue"
                        @input="handleInput"
                        class="ppv2-flex-1 ppv2-outline-none ppv2-text-sm ppv2-uppercase ppv2-text-black ppv2-text-opacity-70 ppv2-min-w-0"
                        maxlength="6"
                        placeholder="FFFFFF"
                        :disabled="disabled"
                    />
                </div>
            </div>

            <!-- Color Picker Popover -->
            <div v-if="showPicker" class="ppv2-absolute ppv2-z-50 ppv2-mt-2" v-click-outside="closePicker">
                <div class="ppv2-fixed ppv2-inset-0 ppv2-z-40" @click="closePicker"></div>
                <div class="ppv2-relative ppv2-z-50">
                    <sketch-picker :value="modelValue" @input="updateColor" />
                </div>
            </div>
        </div>

        <!-- Error Text -->
        <p v-if="errorText" class="error-text">
            {{ Array.isArray(errorText) ? errorText[0] : errorText }}
        </p>
    </div>
</template>

<script>
import { Sketch } from 'vue-color'
import BaseLabel from './BaseLabel.vue'

export default {
    name: 'BaseColorInput',
    components: {
        'sketch-picker': Sketch,
        BaseLabel,
    },
    props: {
        customClassLabel: {
            type: String,
            default: '',
        },
        customContainerClass: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '#FFFFFF',
        },
        label: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        iconRight: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        errorText: {
            type: [String, Array],
            default: '',
        },
    },
    data() {
        return {
            showPicker: false,
        }
    },
    computed: {
        modelValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
        displayValue() {
            return this.modelValue ? this.modelValue.replace('#', '') : ''
        },
    },
    methods: {
        togglePicker() {
            if (this.disabled) return
            this.showPicker = !this.showPicker
        },
        closePicker() {
            this.showPicker = false
        },
        updateColor(color) {
            this.modelValue = color.hex
        },
        handleInput(e) {
            let val = e.target.value
            // Ensure valid hex characters
            val = val.replace(/[^0-9A-Fa-f]/g, '').slice(0, 6)
            this.modelValue = '#' + val
        },
    },
}
</script>

<style scoped>
.error-text {
    color: #ed4b9e;
    font-size: clamp(10px, 0.625vw, 22px);
    margin-top: 4px;
}
</style>
